import BaseBanner from './BaseBanner'
import BaseModule from './BaseModule'
export default {
    BaseBanner,
    BaseModule
}